import React from 'react';
import '../styles/OurStory.css'; // Import the CSS file for styling

const OurStory = () => (
    <div className="coming-soon-container">
        <h1 className="coming-soon-message">Coming Soon...</h1>
    </div>
);

export default OurStory;